import { useId } from 'react';

import { MultipleArrayInput } from '@/components/MultipleArrayInput';

import { EMAIL_REGEX } from '../utils/constants';

export function BulkEmailAddressInput(props: {
  className?: string;
  value: string[];
  maxMemberCount: number;
  onChange: (value: string[]) => void;
  label: string;
  memberCount: number;
}) {
  const id = useId();
  const maxLength = Math.max(0, props.maxMemberCount - props.memberCount);

  return (
    <div className="flex flex-col items-stretch gap-2">
      <label className="text-sm font-medium" htmlFor={id}>
        {props.label}
      </label>

      <MultipleArrayInput
        id={id}
        onChange={props.onChange}
        value={props.value}
        className={props.className}
        separators={/[,\s]/}
        maxLength={maxLength}
        validate={(text) => !!text.trim() && text.match(EMAIL_REGEX) != null}
      />

      <div className="text-sm">
        {maxLength === 1
          ? 'Type up to 1 email address.'
          : `Type up to ${maxLength} email addresses separated by commas.`}
      </div>
    </div>
  );
}
